import * as Yup from 'yup';

export const equipmentFormSchema = Yup.object().shape({
  equipmentName: Yup.string().required('Name is required'),
  notes: Yup.string().required('Note is required'),
});
